import { asNumberOrNull, asString } from './report-formatting.utils';
import { isRecord } from './report-json.utils';

export function getPathValue(source: unknown, path: string): unknown {
   if (!path) {
      return undefined;
   }

   let currentValue: unknown = source;

   for (const pathPart of path.split('.')) {
      if (!isRecord(currentValue)) {
         return undefined;
      }

      currentValue = currentValue[pathPart];
   }

   return currentValue;
}

export function getFirstValue(source: unknown, paths: readonly string[]): unknown {
   for (const path of paths) {
      const value = getPathValue(source, path);

      if (value !== null && value !== undefined && value !== '') {
         return value;
      }
   }

   return undefined;
}

export function getFirstString(source: unknown, paths: readonly string[]): string {
   return asString(getFirstValue(source, paths));
}

export function getFirstNumber(
   source: unknown,
   paths: readonly string[]
): number | null {
   for (const path of paths) {
      const amount = asNumberOrNull(getPathValue(source, path), {
         removeGroupingSeparators: true
      });

      if (amount !== null) {
         return amount;
      }
   }

   return null;
}
